export default {"src":"/_next/static/media/show-password.b0cfc1e8.svg","height":14,"width":21};